import React from 'react';
import Skeleton from '@srm/ui/skeleton';

interface INotificationDropdownSkeletonProps {
    /**
     * Число карточек-заглушек.
     * @default 6
     */
    count?: number;
}

// Скелетон списка уведомлений: повторяет форму карточки (точка + тема / превью в две
// строки / подвал с чипом категории и временем). Показывается на первичной загрузке и
// догрузке страницы вместо кругового спиннера — форма списка стабильна и известна.
// Ширины варьируются детерминированно по индексу (без random — VR-кадр стабилен).
const NotificationDropdownSkeleton: React.FC<INotificationDropdownSkeletonProps> = ({ count = 6 }) => (
    <div className="rf-notification-dropdown__skeleton" aria-hidden="true">
        {Array.from({ length: count }).map((_, i) => (
            <div className="rf-notification-dropdown__sk-item" key={i}>
                <div className="rf-notification-dropdown__sk-header">
                    <Skeleton width={8} height={8} circle />
                    <Skeleton height={13} width={`${52 + ((i * 7) % 24)}%`} radius="sm" />
                </div>
                <Skeleton height={10} width="94%" radius="sm" mb={5} />
                <Skeleton height={10} width={`${58 + ((i * 5) % 22)}%`} radius="sm" />
                <div className="rf-notification-dropdown__sk-footer">
                    <Skeleton height={18} width={104} radius="xl" />
                    <Skeleton height={10} width={36} radius="sm" />
                </div>
            </div>
        ))}
    </div>
);

export default NotificationDropdownSkeleton;
